var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 58,
    viewBox: "0 0 59 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "medal_13676963 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    transform: "translate(0.679688)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "medal_award"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.68 12.6875C29.216 12.6875 28.752 12.5099 28.3986 12.1564L21.1486 4.90644C20.6302 4.38806 20.4743 3.60869 20.7553 2.93081C21.0362 2.25475 21.6978 1.8125 22.43 1.8125H36.93C37.6623 1.8125 38.3238 2.25475 38.6048 2.93081C38.8857 3.60869 38.7298 4.38806 38.2115 4.90644L30.9615 12.1564C30.608 12.5099 30.144 12.6875 29.68 12.6875ZM26.8054 5.4375L29.68 8.31212L32.5547 5.4375H26.8054Z",
    fill: "#FFCC2F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M29.6797 48.9375C18.6869 48.9375 9.74219 39.9928 9.74219 29C9.74219 18.0072 18.6869 9.0625 29.6797 9.0625C40.6725 9.0625 49.6172 18.0072 49.6172 29C49.6172 39.9928 40.6725 48.9375 29.6797 48.9375ZM29.6797 12.6875C20.6861 12.6875 13.3672 20.0064 13.3672 29C13.3672 37.9936 20.6861 45.3125 29.6797 45.3125C38.6733 45.3125 45.9922 37.9936 45.9922 29C45.9922 20.0064 38.6733 12.6875 29.6797 12.6875Z",
    fill: "#FF911C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M55.0547 56.1875H40.5547C39.5542 56.1875 38.7422 55.3755 38.7422 54.375C38.7422 53.3745 39.5542 52.5625 40.5547 52.5625H55.0547C56.0552 52.5625 56.8672 53.3745 56.8672 54.375C56.8672 55.3755 56.0552 56.1875 55.0547 56.1875ZM36.9297 54.375C36.9297 53.3745 36.1177 52.5625 35.1172 52.5625H31.4922C30.4917 52.5625 29.6797 53.3745 29.6797 54.375C29.6797 55.3755 30.4917 56.1875 31.4922 56.1875H35.1172C36.1177 56.1875 36.9297 55.3755 36.9297 54.375ZM27.8672 54.375C27.8672 53.3745 27.0552 52.5625 26.0547 52.5625H4.30469C3.30419 52.5625 2.49219 53.3745 2.49219 54.375C2.49219 55.3755 3.30419 56.1875 4.30469 56.1875H26.0547C27.0552 56.1875 27.8672 55.3755 27.8672 54.375Z",
    fill: "#FFCC2F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M29.6797 41.6875C22.6834 41.6875 16.9922 35.9963 16.9922 29C16.9922 22.0038 22.6834 16.3125 29.6797 16.3125C30.6802 16.3125 31.4922 17.1245 31.4922 18.125C31.4922 19.1255 30.6802 19.9375 29.6797 19.9375C24.6826 19.9375 20.6172 24.0029 20.6172 29C20.6172 33.9971 24.6826 38.0625 29.6797 38.0625C34.0569 38.0625 37.7181 34.9432 38.5591 30.8125H29.6797C28.6792 30.8125 27.8672 30.0005 27.8672 29C27.8672 27.9995 28.6792 27.1875 29.6797 27.1875H40.5547C41.5552 27.1875 42.3672 27.9995 42.3672 29C42.3672 35.9963 36.6759 41.6875 29.6797 41.6875Z",
    fill: "#FFCC2F"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.083f238aec7a88e05b5b19c52c24580d.svg";
export { ForwardRef as ReactComponent };